<form class="flex w100p">
  <!-- Title -->
  <div *ngIf="payload.properties.text?.value">
    <label class="flex">
      <span class="field-label-content">
        <div style="display: inline" [innerHTML]="payload.properties.text?.value | tokenToDiv"></div>
        <span class="required" *ngIf="payload.properties.required.value">*</span>
        <fb-scribe-suggestion-indicator [target]="payload"></fb-scribe-suggestion-indicator>
        <fb-amendment-field-indicator />
      </span>
    </label>
  </div>

  <div class="label-container" *ngIf="payload.properties.content?.value">
    <label class="flex jcc subtitle">
      <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
    </label>
  </div>

  <div class="flex rel ov w100p rel">
    <!-- Desktop -->
    <form class="flex w100p large-resolution">
      <table class="table table-bordered">
        <thead *ngIf="!payload.properties.hideHeader.value">
          <tr>
            <th *ngFor="let col of payload.properties.cols.value" [ngClass]="{ wide: col.properties.wide?.value }">
              <span [innerHTML]="col.properties.value.value.properties.value.value | tokenToDiv"></span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of payload.properties.rows.value; let rowIndex = index">
            <td *ngFor="let col of row.properties.columns.value; let colIndex = index">
              <ng-container [ngSwitch]="col.properties.value.value.name">
                <!-- Text cell -->
                <div *ngSwitchCase="'fb-text'">
                  <span [innerHTML]="col.properties.value.value.properties.value.value | tokenToDiv"></span>
                  <span class="required" *ngIf="payload.properties.required.value">*</span>
                </div>

                <!-- Radio cell -->
                <div *ngSwitchCase="'fb-radio-simple'">
                  <!--
                                        Handling selection using unified method onRowSelectionChange
                                        This ensures legacy and new formats stay in sync
                                    -->
                  <mat-radio-group
                    [value]="row.properties.selected"
                    (change)="onRowSelectionChange(row, $event.value)"
                    [name]="payload.id + '_row_' + rowIndex + '_table_' + 0"
                    class="flex"
                  >
                    <mat-radio-button [value]="colIndex">
                      <span [innerHTML]="col.properties.value.value.properties.text.value | tokenToDiv"></span>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </form>

    <!-- Mobile -->
    <div class="flex small-resolution">
      <div *ngFor="let row of payload.properties.rows.value; let rowIndex = index">
        <div *ngFor="let col of row.properties.columns.value; let colIndex = index" class="flex flex-row aic">
          <ng-container [ngSwitch]="col.properties.value.value.name">
            <!-- Text cell -->
            <div *ngSwitchCase="'fb-text'">
              <label>
                <span [innerHTML]="col.properties.value.value.properties.value.value | tokenToDiv"></span>
                <span class="required" *ngIf="payload.properties.required.value">*</span>
              </label>
            </div>

            <!-- Radio cell -->
            <div *ngSwitchCase="'fb-radio-simple'">
              <mat-radio-group
                [value]="row.properties.selected"
                (change)="onRowSelectionChange(row, $event.value)"
                [name]="payload.id + '_row_' + rowIndex + '_table_' + 1"
                class="flex"
              >
                <mat-radio-button [value]="colIndex">
                  {{ payload.properties.cols.value[colIndex].properties.value.value.properties.value.value }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Error message -->
  <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
    This field is required
  </div>
</form>
